import { apiClient } from '~/api/client';

type Params = {
  user_id: string;
  role: string;
  sort: string;
};

export const update = async (params: Params) => {
  const sort = params.sort === 'Alphabetical [A-Z]' ? 'asc' : 'desc';
  return apiClient.put(`/users/${params.user_id}/role`, {
    role: params.role,
    sort: sort,
  });
};
